import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router";
import { applyLocationAttrs } from "./OtelSpan.js";
const routing = "route";
const routingAttributes = { ROUTE_PREV_PATHNAME: `${routing}.prev_pathname`, ROUTE_CURRENT_PATHNAME: `${routing}.current_pathname` };
const routingSpanName = "ROUTING CLIENT";
const TraceContext = React.createContext({ tracingService: null });
const TraceProvider = ({ children, tracingService }) => {
  const location = useLocation();
  const prevLocationPathname = useRef(null);
  useEffect(() => {
    if (prevLocationPathname.current !== location.pathname) {
      handleLocationChange(prevLocationPathname.current, location.pathname);
      prevLocationPathname.current = location.pathname;
    }
  }, [location]);
  function handleLocationChange(prevPathname, currentPathname) {
    const tracer = tracingService.getTracer();
    const span = tracer.startSpan(routingSpanName, {
      attributes: {
        [routingAttributes.ROUTE_PREV_PATHNAME]: prevPathname,
        [routingAttributes.ROUTE_CURRENT_PATHNAME]: currentPathname
      }
    });
    applyLocationAttrs(span);
    tracingService.endSpanOk(span);
  }
  return /* @__PURE__ */ React.createElement(TraceContext.Provider, { value: { tracingService } }, children);
};
export {
  TraceContext,
  TraceProvider
};
//# sourceMappingURL=TraceProvider.js.map
